export const SEARCHBAR_ITEM_DISPLAY_NAME = 'SearchBarItem'
export const SEARCHBAR_EXTRA_DISPLAY_NAME = 'SearchBarExtra'

export const isSearchBarItem = comp => {
  return comp.type && comp.type.displayName === SEARCHBAR_ITEM_DISPLAY_NAME
}

export const isSearchBarExtra = comp => {
  return comp.type && comp.type.displayName === SEARCHBAR_EXTRA_DISPLAY_NAME
}
